import { baseApi } from "./baseApi";

const vestaContactsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVestaContacts: builder.query({
      query: () => ({
        url: "/vesta-contacts",
        method: "GET",
      }),
      providesTags: ["VestaContacts"],
    }),

    getVestaContact: builder.query({
      query: (fileContactId) => ({
        url: `/vesta-contacts/${fileContactId}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "VestaContacts", id }],
    }),

    createVestaContact: builder.mutation({
      query: (body) => ({
        url: "/vesta-contacts",
        method: "POST",
        body,
      }),
      invalidatesTags: ["VestaContacts"],
    }),

    pushContactToVesta: builder.mutation({
      query: (body) => ({
        url: "/vesta-contacts/push",
        method: "POST",
        body,
      }),
      invalidatesTags: ["VestaContacts"],
    }),

    pullContactFromVesta: builder.mutation({
      query: (body) => ({
        url: "/vesta-contacts/pull",
        method: "POST",
        body,
      }),
      invalidatesTags: ["VestaContacts"],
    }),

    pullCompanyFromVesta: builder.mutation({
      query: (body) => ({
        url: "/vesta-contacts/pull-company",
        method: "POST",
        body,
      }),
      invalidatesTags: ["VestaContacts", "BrokerCompanies"],
    }),

    assignUserRole: builder.mutation({
      query: ({ userId, role }) => ({
        url: `/users/${userId}/assign-role`,
        method: "POST",
        body: { role },
      }),
      invalidatesTags: ["VestaContacts"],
    }),

    getSyncComparison: builder.query({
      query: (brokerCompanyId) => ({
        url: `/vesta-contacts/sync/${brokerCompanyId}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [
        "VestaContacts",
        { type: "VestaContacts", id: `sync-${id}` },
      ],
    }),
  }),
});

export const {
  useGetVestaContactsQuery,
  useGetVestaContactQuery,
  useCreateVestaContactMutation,
  usePushContactToVestaMutation,
  usePullContactFromVestaMutation,
  usePullCompanyFromVestaMutation,
  useAssignUserRoleMutation,
  useGetSyncComparisonQuery,
} = vestaContactsApi;

export default vestaContactsApi;
